import service from "./axiosConfig"

// AI问答相关 API

/**
 * 原AI问答接口（同步，等待完整响应）
 * @param {string} question - 问题内容
 * @param {string} historyText - 历史对话文本
 */
export function wrjAiAnswer(question, historyText) {
  return service.post("/interface/wrj/ai", {
    question: question,
    historyText: historyText || ''
  });
}

/**
 * 获取AI对话历史
 */
export function getAiTalkHistory() {
  return service.get("/interface/wrj/ai/history");
}

/**
 * 清空AI对话历史
 */
export function clearAiTalkHistory() {
  return service.delete("/interface/wrj/ai/history/clear");
}
